export const RESTORE_STATE = 'RESTORE_STATE';

export function loadState() {
  try {
    const serializedState = localStorage.getItem('indigenetg2s_inv_state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export function saveState(state) {
  try {
    const {dispensary: {selectedDispensaryId}, auth: {token}} = state;
    const toSave = {dispensary: {selectedDispensaryId}, auth: {token}};
    const serializedState = JSON.stringify(toSave);
    localStorage.setItem('indigenetg2s_inv_state', serializedState);
  } catch (err) {
    // ignore write errors
  }
}



// WEBPACK FOOTER //
// ./src/persistState.js